import PageCreateEditQuestion from './PageCreateEditQuestion';



export default PageCreateEditQuestion;
